/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Recovery_Code_InvalidInputs */



/**
* | output |
* | --- |
* | "The recovery code you entered is invalid. Please check and try again." |
*
* @param {Auth_Recovery_Code_InvalidInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const auth_recovery_code_invalid = /** @type {((inputs?: Auth_Recovery_Code_InvalidInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Recovery_Code_InvalidInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Ungültiger Wiederherstellungscode. Bitte überprüfe den Code und versuche es erneut.")
	return /** @type {LocalizedString} */ ("The recovery code you entered is invalid. Please check and try again.")
});